import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'request-confirm',
  templateUrl: './request-confirm.component.html',
  styleUrls: ['./request-confirm.component.css']
})
export class RequestConfirmComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
